import { Button } from '@warp-ds/react/components/button';
import emptyState from '@/static/icons/emptyState.svg';

export type EmptyWarningProps = {
    onReset: () => void;
    testId?: string;
};

export const EmptyWarning = ({ onReset, testId = 'emptyWarning' }: EmptyWarningProps) => (
    <section className="flex flex-col gap-24 items-center my-32" data-testid={testId}>
        <div className="flex flex-col gap-8 items-center">
            <h3>Vi fant ingen reiser på søket ditt</h3>
            <p>Hvis du endrer på kriteriene kan vi finne en annen reise til deg.</p>
            <Button data-testid={`${testId}Button`} onClick={onReset}>
                Nullstill søket
            </Button>
        </div>
        <img
            src={emptyState.src}
            height={emptyState.height}
            width={emptyState.width}
            loading="lazy"
            alt="Katt som har en pote hvilende på en badeball"
        />
    </section>
);
